module.exports = __webpack_public_path__ + "static/media/BACheckboxEmpty.641c6b26.svg";